import styled from "styled-components";
import { Header } from "../organisms/Header";

type Props = {
  children: React.ReactNode;
};

export const MaintenanceTemplate: React.FC<Props> = ({ children }) => {
  return (
    <MainContainer>
      <Header
        showAppCouponHeader={false}
        menusToReorder={null}
        requiredLogout={false}
        isMaintenance
      />
      <OutletContainer>{children}</OutletContainer>
    </MainContainer>
  );
};

const MainContainer = styled.main<{ $showAppLinkageFooter?: boolean }>`
  margin-bottom: ${({ $showAppLinkageFooter }) =>
    $showAppLinkageFooter ? "80px" : "0"};
`;

const OutletContainer = styled.div`
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 54px;
  min-width: 375px;
  min-height: calc(100vh - 54px - 98px);
`;
